/* IKAI — main.js (performance + error fix, Sep 2026)
   - Null guards: agar section page pe nahi hai to skip. Pehle har page pe
     "Cannot read properties of null (reading 'children')" TypeError aata tha
     (#pmSlider / #testimonialSlider / #bannerSlider homepage pe exist nahi karte).
   - 4 copy-paste slider blocks -> 1 function, same behaviour.
   - Arrow buttons ab usi section ke andar dhoondhe jaate hain (global .pm-next collision nahi).
   - Clones: aria-hidden + tabindex=-1 (screen reader / keyboard duplicate fix).
   - Autoplay: tab hidden / slider offscreen / hover pe pause; prefers-reduced-motion respect.
   - Resize debounced, slide width cached (layout thrash kam).
   - Theme editor: shopify:section:load pe re-init.
*/
(function () {
  'use strict';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var SLIDERS = [
    { id: 'pmSlider',          next: '.pm-next',      prev: '.pm-prev',      autoplay: 3000 },
    { id: 'testimonialSlider', next: '.test-next',    prev: '.test-prev',    autoplay: 10000 },
    { id: 'receipeslider',     next: '.receipe-next', prev: '.receipe-prev', autoplay: 0 },
    { id: 'bannerSlider',      next: '.banner-next',  prev: '.banner-prev',  autoplay: 3000 }
  ];

  function findButton(slider, selector) {
    var scope = slider.closest('.shopify-section') || slider.parentNode || document;
    return scope.querySelector(selector) || document.querySelector(selector);
  }

  function initLoopSlider(cfg) {
    var slider = document.getElementById(cfg.id);
    if (!slider || slider.dataset.pmReady === '1') return;

    var original = Array.prototype.slice.call(slider.children);
    if (!original.length) return;
    slider.dataset.pmReady = '1';

    // Duplicate slides for infinite loop (clones hidden from assistive tech)
    original.forEach(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      c.querySelectorAll('a, button, input, select, textarea, video, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      c.querySelectorAll('img').forEach(function (img) { img.setAttribute('loading', 'lazy'); });
      slider.appendChild(c);
    });

    var half = slider.children.length / 2;
    var index = 0;
    var w = 0;
    var timer = null;
    var visible = true;
    var hovered = false;

    function measure() {
      var first = slider.children[0];
      w = (first ? first.offsetWidth : 0) + 25; // 25 = gap (same as before)
    }
    function apply(animate) {
      slider.style.transition = animate ? 'transform 0.4s ease' : 'none';
      slider.style.transform = 'translateX(-' + index * w + 'px)';
    }
    function resetLoop() {
      if (index >= half) { index = 0; apply(false); }
    }
    function next() {
      if (!w) measure();
      index++;
      apply(true);
      slider.addEventListener('transitionend', resetLoop, { once: true });
    }
    function prev() {
      if (!w) measure();
      index--;
      if (index < 0) index = half - 1;
      apply(true);
    }

    var nextBtn = findButton(slider, cfg.next);
    var prevBtn = findButton(slider, cfg.prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    function canPlay() { return cfg.autoplay && !reduceMotion && visible && !hovered && !document.hidden; }
    function sync() {
      if (canPlay()) { if (!timer) timer = setInterval(next, cfg.autoplay); }
      else if (timer) { clearInterval(timer); timer = null; }
    }

    if (cfg.autoplay) {
      slider.addEventListener('mouseenter', function () { hovered = true; sync(); });
      slider.addEventListener('mouseleave', function () { hovered = false; sync(); });
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.1 }).observe(slider);
      } else {
        sync();
      }
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); apply(false); }, 150);
    }, { passive: true });

    requestAnimationFrame(measure);
  }

  function boot() {
    SLIDERS.forEach(function (cfg) {
      try { initLoopSlider(cfg); } catch (e) { if (window.console) console.warn('[ikai slider]', cfg.id, e); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
